module.exports = __webpack_public_path__ + "static/media/7.b161d250.jpeg";